export default {
  title: 'Verifique sua identidade',
  subtitle: 'Digite os últimos 4 dígitos do telefone do paciente ou do número do pedido para ver os detalhes da entrega.',
  'type-phone': 'Telefone do paciente (últimos 4 dígitos)',
  'type-order': 'Número do pedido (últimos 4 dígitos)',
  code: 'Últimos 4 dígitos',
  submit: 'Continuar',
  'attempts-remaining': 'Tentativas restantes: {count}',
  blocked: 'Muitas tentativas. Tente novamente em {minutes} min.',
  'invalid-code': 'Código incorreto. Tente novamente.',
  expired: {
    title: 'Link expirado',
    description: 'O acesso a este pedido não está mais disponível (limite de 14 dias).',
  },
  forbidden: {
    title: 'Acesso negado',
    description: 'Você não tem permissão para ver esta página.',
  },
}
